import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DutyEditorState {
  showConsecutiveDutyTooltip: boolean; // 연속근무 여부 (NE, ED, ND)
  showAvoidanceDutyTooltip: boolean; // 기피근무 여부 (NNN, NOD, NOE)
  showFiveDayConsecutiveTooltip: boolean; // 5일 이상 연속 근무 여부
  showPongDangPongDangTooltip: boolean; // 퐁당퐁당 여부 (NONO)

  maxConsecutiveWorkDays: number; // 최대 연속 근무 일수
  useForbiddenPatterns: boolean; // 금지 패턴 (NE, ED, ND) 적용 여부
  useAvoidancePatterns: boolean; // 기피 패턴 (NNN, NOD, NOE) 적용 여부
  usePongDangPatterns: boolean; // 퐁당퐁당 패턴 (NONO) 적용 여부

  setShowConsecutiveDutyTooltip: (show: boolean) => void;
  setShowAvoidanceDutyTooltip: (show: boolean) => void;
  setShowFiveDayConsecutiveTooltip: (show: boolean) => void;
  setShowPongDangPongDangTooltip: (show: boolean) => void;
  setMaxConsecutiveWorkDays: (days: number) => void;
  setUseForbiddenPatterns: (use: boolean) => void;
  setUseAvoidancePatterns: (use: boolean) => void;
  setUsePongDangPatterns: (use: boolean) => void;
}

export const useDutyEditorStore = create<DutyEditorState>()(
  persist(
    (set) => ({
      showConsecutiveDutyTooltip: true,
      showAvoidanceDutyTooltip: true,
      showFiveDayConsecutiveTooltip: true,
      showPongDangPongDangTooltip: true,

      maxConsecutiveWorkDays: 6,
      useForbiddenPatterns: true,
      useAvoidancePatterns: true,
      usePongDangPatterns: true,

      setShowConsecutiveDutyTooltip: (show) => set({ showConsecutiveDutyTooltip: show }),
      setShowAvoidanceDutyTooltip: (show) => set({ showAvoidanceDutyTooltip: show }),
      setShowFiveDayConsecutiveTooltip: (show) => set({ showFiveDayConsecutiveTooltip: show }),
      setShowPongDangPongDangTooltip: (show) => set({ showPongDangPongDangTooltip: show }),
      setMaxConsecutiveWorkDays: (days) => set({ maxConsecutiveWorkDays: days }),
      setUseForbiddenPatterns: (use) => set({ useForbiddenPatterns: use }),
      setUseAvoidancePatterns: (use) => set({ useAvoidancePatterns: use }),
      setUsePongDangPatterns: (use) => set({ usePongDangPatterns: use }),
    }),
    {
      name: "duty-editor-storage",
    },
  ),
);
